/**
 * O preço de um nível, em lamports, sem ponto flutuante.
 *
 * `fator` em bps (20_000 = 2×) para o dinheiro nunca passar por `number`:
 * base × fator^(n-1) / 10000^(n-1), tudo em bigint. Por nível DO ATRIBUTO,
 * não do taco: espalhar é barato e concentrar é caro, e é a concentração que
 * desequilibra.
 */
export type CurvaDePreco = { baseLamports: bigint; fatorBps: number }
export const CURVA_PADRAO: CurvaDePreco = { baseLamports: 1_000_000n, fatorBps: 20_000 }

export function precoDoNivel(nivel: number, curva: CurvaDePreco): bigint {
  if (!Number.isInteger(nivel) || nivel < 1) throw new Error(`nível inválido: ${nivel}`)
  let preco = curva.baseLamports
  for (let i = 1; i < nivel; i++) preco = (preco * BigInt(curva.fatorBps)) / 10_000n
  return preco
}
